// Branded printable invoice / receipt for Lucas & Sons.
const LOGO =
  "https://customer-assets-agu9un31.emergentagent.net/job_144208b3-9494-40cc-b4de-d3df27f3f1f4/artifacts/yz1bso4a_image.png";

const money = (n) =>
  "BZ$" + Number(n || 0).toLocaleString("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 });

const fmt = (s) => {
  try { return new Date(s || Date.now()).toLocaleString("en-GB", { day: "2-digit", month: "short", year: "numeric", hour: "2-digit", minute: "2-digit" }); }
  catch { return s || ""; }
};

export function invoiceHTML(sale) {
  const items = (sale.items || [])
    .map(
      (it) => `<tr>
        <td>${it.name}</td>
        <td class="r">${it.qty}</td>
        <td class="r">${money(it.price)}</td>
        <td class="r">${money(it.price * it.qty)}</td>
      </tr>`
    )
    .join("");

  return `<!doctype html><html><head><meta charset="utf-8"/>
  <title>${sale.invoice_no || "Invoice"} — Lucas & Sons</title>
  <style>
    *{box-sizing:border-box;margin:0;padding:0;font-family:'Segoe UI',Arial,sans-serif}
    body{color:#0f172a;padding:36px;max-width:800px;margin:0 auto}
    .top{display:flex;justify-content:space-between;align-items:flex-start;border-bottom:3px solid #0057B8;padding-bottom:18px}
    .brand{display:flex;gap:14px;align-items:center}
    .brand img{width:70px;height:70px;object-fit:contain;border-radius:10px;border:1px solid #e2e8f0}
    .brand h1{font-size:22px;color:#0057B8;letter-spacing:-.3px}
    .brand p{font-size:12px;color:#64748b;text-transform:uppercase;letter-spacing:2px}
    .co{font-size:12px;color:#475569;text-align:right;line-height:1.6}
    .doc{display:flex;justify-content:space-between;margin-top:22px}
    .doc h2{color:#D62828;font-size:26px;letter-spacing:1px}
    .meta{font-size:13px;color:#475569;line-height:1.7}
    .meta b{color:#0f172a}
    .bill{margin-top:8px;font-size:13px;color:#475569;line-height:1.6}
    .bill .t{font-size:11px;text-transform:uppercase;letter-spacing:1.5px;color:#94a3b8;margin-bottom:4px}
    table{width:100%;border-collapse:collapse;margin-top:24px;font-size:13px}
    th{background:#0057B8;color:#fff;text-align:left;padding:10px 12px;font-size:12px;text-transform:uppercase;letter-spacing:.5px}
    td{padding:10px 12px;border-bottom:1px solid #e2e8f0}
    .r{text-align:right}
    .totals{margin-top:16px;margin-left:auto;width:280px;font-size:13px}
    .totals div{display:flex;justify-content:space-between;padding:6px 0;color:#475569}
    .totals .grand{border-top:2px solid #0057B8;margin-top:6px;padding-top:10px;font-size:18px;font-weight:700;color:#0057B8}
    .pay{margin-top:20px;display:inline-block;background:#eff6ff;color:#0057B8;padding:6px 14px;border-radius:999px;font-size:12px;font-weight:600;text-transform:capitalize}
    .foot{margin-top:44px;border-top:1px solid #e2e8f0;padding-top:16px;text-align:center;color:#94a3b8;font-size:12px;line-height:1.7}
    .foot .thanks{color:#D62828;font-weight:600;font-size:14px}
    @media print{body{padding:12px}@page{margin:12mm}}
  </style></head>
  <body>
    <div class="top">
      <div class="brand">
        <img src="${LOGO}" alt="Lucas & Sons"/>
        <div><h1>Lucas &amp; Sons</h1><p>Butane Gas Service</p></div>
      </div>
      <div class="co">
        San Juan, Cayo District<br/>Belize, C.A.<br/>Tel: +501-600-0000<br/>info@lucasandsons.bz
      </div>
    </div>

    <div class="doc">
      <div>
        <div class="bill">
          <div class="t">Billed To</div>
          <b style="color:#0f172a;font-size:15px">${sale.customer_name || "Walk-in Customer"}</b>
        </div>
        <div class="pay">Payment: ${sale.payment_type || "cash"}</div>
      </div>
      <div style="text-align:right">
        <h2>INVOICE</h2>
        <div class="meta">
          <div><b>No:</b> ${sale.invoice_no || "-"}</div>
          <div><b>Date:</b> ${fmt(sale.created_at)}</div>
          <div><b>Served by:</b> ${sale.cashier || "-"}</div>
        </div>
      </div>
    </div>

    <table>
      <thead><tr><th>Item</th><th class="r">Qty</th><th class="r">Unit</th><th class="r">Amount</th></tr></thead>
      <tbody>${items || '<tr><td colspan="4">No items</td></tr>'}</tbody>
    </table>

    <div class="totals">
      <div><span>Subtotal</span><span>${money(sale.subtotal)}</span></div>
      ${Number(sale.discount) ? `<div><span>Discount</span><span>-${money(sale.discount)}</span></div>` : ""}
      ${Number(sale.deposit) ? `<div><span>Cylinder Deposit</span><span>${money(sale.deposit)}</span></div>` : ""}
      <div class="grand"><span>TOTAL</span><span>${money(sale.total)}</span></div>
      ${Number(sale.amount_tendered) ? `<div><span>Cash Received</span><span>${money(sale.amount_tendered)}</span></div>` : ""}
      ${Number(sale.amount_tendered) ? `<div><span>Change</span><span>${money(sale.change)}</span></div>` : ""}
    </div>

    <div class="foot">
      <div class="thanks">Thank you for your business!</div>
      Safe. Reliable. Local. — Serving San Juan &amp; the Cayo District.<br/>
      Cylinder deposits are refundable on return of company-owned cylinders in good condition.
    </div>
  </body></html>`;
}

export function printInvoice(sale) {
  const w = window.open("", "_blank", "width=820,height=900");
  if (!w) return;
  w.document.write(invoiceHTML(sale));
  w.document.close();
  const go = () => { w.focus(); w.print(); };
  const img = w.document.querySelector("img");
  if (img && !img.complete) { img.onload = go; img.onerror = go; setTimeout(go, 1200); }
  else setTimeout(go, 350);
}
